// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"eventPageSideBar_sidebar__3twg1","section":"eventPageSideBar_section__3g9xe","sectionEditorForm":"eventPageSideBar_sectionEditorForm__28Kgt","btnCloseOrOpenSideBar":"eventPageSideBar_btnCloseOrOpenSideBar__1PCkT","opened":"eventPageSideBar_opened__3ntGm","sidebarOpen":"eventPageSideBar_sidebarOpen__2sXoG","sidebarClose":"eventPageSideBar_sidebarClose__c6NdL"};
    if(module.hot) {
      // 1783592057835
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  